import { defaultStore } from 'app/gamma/src/defaultStore';
import { featureFlagClient } from '@trello/feature-flag-client';
import {
  setHeaderBrandingColor,
  removeHeaderBrandingColor,
  setHeaderBrandingLogo,
  removeHeaderBrandingLogo,
} from 'app/gamma/src/modules/state/ui/header';

interface HeaderOptions {
  headerBrandingColor?: string;
  headerBrandingLogo?: string;
}

export const headerBranding = (opts: HeaderOptions) => {
  const isHeaderBrandingEnabled = featureFlagClient.get(
    'enterprise.branding',
    false,
  );

  if (opts.headerBrandingLogo && isHeaderBrandingEnabled) {
    defaultStore.dispatch(setHeaderBrandingLogo(opts.headerBrandingLogo));
  } else {
    defaultStore.dispatch(removeHeaderBrandingLogo());
  }

  if (opts.headerBrandingColor && isHeaderBrandingEnabled) {
    defaultStore.dispatch(setHeaderBrandingColor(opts.headerBrandingColor));
  } else {
    defaultStore.dispatch(removeHeaderBrandingColor());
  }
};
